// /src/pwa/pages/AndroidInstall.jsx
import React , { useState } from 'react';
import '../styles/pwa.css';
import '../styles/install-guide.css';



export default function AndroidInstall({ deferredPrompt, onInstalled }) {
    const handleInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        // outcome: 'accepted' | 'dismissed'
        if (outcome === 'accepted') {
        // ユーザが承諾 → OS側のインストールダイアログへ
        // 成功時は 'appinstalled' イベントが飛ぶのでそこで onInstalled を呼ぶのが安全
        }
    };

    function Header() {
        return (
            <header className="ig-header">
            <img className="ig-logo" src="/pwa/guide/logo-hospital.png" alt="北村皮膚科クリニック" />
            </header>
        );
    }


    const videoSrc = '/pwa/guide/install-ios.mp4';
    const poster   = '/pwa/guide/install-poster.jpg';
    
    const steps = [
        { img: '/pwa/guide/stepA1.jpg', title: 'ホーム画面に追加',   desc: '「ホーム画面に追加」ボタンをタップ' },
        { img: '/pwa/guide/stepA2.jpg', title: 'インストール',   desc: '「インストール」ボタンをタップ' },
        { img: '/pwa/guide/stepA3.jpg', title: 'アイコン表示', desc: 'アイコンが表示されればインストール成功です' },
    ];

    // ライトボックス
    const [zoomSrc, setZoomSrc] = useState(null);


  return (
    <div className="line-container">

        <div className="ig-wrap">
            <Header />
            <h1 className="ig-h1">アプリのインストール（Android）</h1>
            <p className="ig-lead">
            ホーム画面に追加すると、LINEと同じように受付番号予約が可能です。
            下のボタンをタップすると、ホーム画面に追加できます。
            </p>

            <button className="line-primary-btn line-primary-btn--xl"
            onClick={handleInstall}
            disabled={!deferredPrompt}>
            ホーム画面に追加
            </button>

            {!deferredPrompt && (
            <p className="line-muted" style={{ marginTop: 8 }}>
                （例：manifest / Service Worker / HTTPS）
            </p>
            )}

            <h1 className="ig-h1">アプリのインストール方法（Android）</h1>
            <p className="ig-lead">
            以下の手順でアプリをインストールしてください。
            </p>

            <div className="ig-videoBox">
                <video src={videoSrc} poster={poster} controls playsInline muted className="ig-video" />
                <div className="ig-caption">※端末・ブラウザによりUIが異なる場合があります</div>
            </div>

            <ol className="ig-steps">
                {steps.map((s, i) => (
                <li key={i} className="ig-stepItem">
                    <img
                    src={s.img}
                    alt={s.title}
                    className="ig-stepImg"
                    onClick={() => setZoomSrc(s.img)}
                    loading="lazy"
                    />
                    <div>
                    <div className="ig-stepTitle">{i + 1}. {s.title}</div>
                    <div className="ig-stepDesc">{s.desc}</div>
                    </div>
                </li>
                ))}
            </ol>

            {/* ライトボックス */}
            {zoomSrc && (
                <div className="ig-lightbox" onClick={() => setZoomSrc(null)} role="dialog" aria-modal="true">
                <button className="ig-lightbox-close" onClick={() => setZoomSrc(null)}>閉じる</button>
                <img src={zoomSrc} alt="拡大画像" />
                </div>
            )}


        </div>
    </div>
  );
}